module.exports = __webpack_public_path__ + "static/media/upload-arrow-icon.a61831fd.svg";